<template>
  <footer
    class="max-md:hidden bg-bgmain rounded-t-3xl w-full mx-auto max-w-[1460px] mt-[4rem] grid grid-cols-[1fr_1fr_auto] px-[3.125rem] pt-10 gap-y-4 pb-4 gap-x-14"
  >
    <div class="border-r border-bgnew">
      <NuxtLink to="/publisher">
        <img src="~/assets/svg/logo.svg" alt="Data Light Project - publisher place" class="h-10" />
      </NuxtLink>
    </div>
    <div class="space-y-2.5 pt-4 border-r border-bgnew">
      <div class="text-base font-medium">Полезные ссылки</div>
      <div>
        <NuxtLink class="text-sm font-normal text-txprimary" to="/publisher"
          >Кабинет паблишера</NuxtLink
        >
      </div>
      <div>
        <NuxtLink class="text-sm font-normal text-txprimary" to="/about">О нас</NuxtLink>
      </div>
      <div>
        <NuxtLink class="text-sm font-normal text-txprimary" to="/blog">Блог</NuxtLink>
      </div>
      <div>
        <NuxtLink class="text-sm font-normal text-txprimary" to="/contacts">Контакты</NuxtLink>
      </div>
      <div>
        <NuxtLink class="text-sm font-normal text-txprimary" to="/help">База знаний</NuxtLink>
      </div>
    </div>
    <div class="space-y-2.5 pt-4">
      <div class="text-base font-medium">ООО “СошелДжет рус”</div>
      <div class="text-sm font-normal text-txprimary">
        127018, г. Москва, вн. тер. г. муниципальный округ Марьина роща, ул. Сущёвский Вал, д. 49, помещ. 207
      </div>
      <div class="text-sm font-normal text-txprimary">+7 (495) 768 58 65</div>
      <div class="text-sm font-normal text-txprimary">partners@socialjet.pro</div>
      <div class="flex items-center gap-4">
        <NuxtLink
          to="https://t.me/TelePost_news"
          target="_blank"
          rel="noopener noreferrer"
          class="flex size-[30px] shrink-0 items-center justify-center"
        >
          <UINewIconsITelegramLight
            class="size-[30px] shrink-0 !fill-primary cursor-pointer"
            currentColor="text-primary"
          />
        </NuxtLink>
        <UINewIconsIVk
          class="size-[30px] shrink-0 !fill-primary cursor-pointer"
          currentColor="text-primary"
        />
        <UINewIconsIDzen
          class="size-[30px] shrink-0 !fill-primary cursor-pointer"
          currentColor="text-primary"
        />
      </div>
    </div>
    <div class="col-span-3 bg-bgnew h-[1px]" />
    <div class="">© 2015–{{ new Date().getFullYear() }} Socialjet</div>
    <div class="">
      <span class="font-medium mr-4">Поддержка:</span>
      <NuxtLink to="https://t.me/suptelepost" target="_blank">@suptelepost</NuxtLink>
    </div>
    <div>
      <NuxtLink to="/documents" target="_blank" class="text-sm font-normal hover:underline mr-4">
        Юридические документы
      </NuxtLink>
      <a href="/pdf/politic.pdf" target="_blank" class="text-sm font-normal hover:underline">
        Политика конфиденциальности
      </a>
    </div>
  </footer>

  <footer class="md:hidden bg-white rounded-t-3xl mt-9 p-5 w-full">
    <div>
      <NuxtLink to="/publisher">
        <img src="~/assets/svg/logo.svg" alt="Data Light Project - publisher place" class="h-10" />
      </NuxtLink>
    </div>
    <div class="my-6 space-y-3 flex flex-col">
      <NuxtLink to="/catalog" class="text-sm text-txprimary font-normal">Каталог</NuxtLink>
      <NuxtLink to="/publisher" class="text-sm text-txprimary font-normal"
        >Кабинет паблишера</NuxtLink
      >
      <NuxtLink to="/" class="text-sm text-txprimary font-normal">О нас</NuxtLink>
      <NuxtLink to="/blog" class="text-sm text-txprimary font-normal">Блог</NuxtLink>
      <NuxtLink to="/contacts" class="text-sm text-txprimary font-normal">Контакты</NuxtLink>
      <NuxtLink to="/help" class="text-sm text-txprimary font-normal">База знаний</NuxtLink>
    </div>
    <div class="flex items-center gap-4">
      <NuxtLink
        to="https://t.me/TelePost_news"
        target="_blank"
        rel="noopener noreferrer"
        class="flex size-[30px] shrink-0 items-center justify-center"
      >
        <UINewIconsITelegramLight
          class="size-[30px] shrink-0 !fill-primary cursor-pointer"
          currentColor="text-primary"
        />
      </NuxtLink>
      <UINewIconsIVk
        class="size-[30px] shrink-0 !fill-primary cursor-pointer"
        currentColor="text-primary"
      />
      <UINewIconsIDzen
        class="size-[30px] shrink-0 !fill-primary cursor-pointer"
        currentColor="text-primary"
      />
    </div>

    <div class="mt-6">
      Поддержка: <NuxtLink to="https://t.me/suptelepost" target="_blank">@suptelepost</NuxtLink>
    </div>

    <div class="h-[1px] bg-[#E3E8EB] w-full my-6" />
    <div class="space-y-3 flex flex-col">
      <a
        href="/pdf/politic.pdf"
        target="_blank"
        class="text-sm text-primary font-normal"
        >Политика конфиденциальности</a
      >
      <NuxtLink to="/documents" target="_blank" class="text-sm text-primary font-normal"
        >Юридические документы</NuxtLink
      >
    </div>
    <div class="flex items-center gap-4 mt-6">
      <NuxtImg src="/assets/img/mc.svg" alt="logo" class="h-[1.275rem]" />
      <NuxtImg src="/assets/img/visa.svg" alt="logo" class="h-[1.175rem]" />
      <NuxtImg src="/assets/img/mir.svg" alt="logo" class="h-[1.175rem]" />
    </div>
    <div class="mt-6">© 2015–{{ new Date().getFullYear() }} Socialjet</div>
  </footer>
</template>

<script lang="ts" setup></script>

<style></style>
